export const URI_PATHS = {
  LOGIN: "/login",
  PREAPPROVAL_DASHBOARD: "/home",
  RELINK_BANK: "/relink",
  RESUME_APPLICATION: "/resumeapplication",
  BASIC_INFO: "/basicinfo",
  VERIFY_PHONE: "/verifyphone",
  ADDRESS: "/address",
  VERIFY_IDENTITY: "/personalinformation",
  LINK_BANK: "/linkbank",
  STUDENT: "/student",
  CONFIRM: "/confirm",
  DECISION: "/decision",
  DASHBOARD: "/dashboard",
};

export const API_ROUTES = {
  USER_EXISTS: "/users/userExists",
  NEW_USER_RECORD: "/users/newUserFromLanding",
  UPDATE_USER_BASIC_INFO: "/newUserSignup_v2",
  GET_ONBOARDING_CONFIG: "/getOnboardingConfigs",
};

export const SUPPORT_URL = `${process.env.REACT_APP_DOMAIN}/support`;
export const LEARN_MORE_URL = `${process.env.REACT_APP_DOMAIN}/faq`;
export const DASHBOARD_URL = `${process.env.REACT_APP_DOMAIN}/dashboard`;
